const zh = {
  common: { updated: "最后更新", back: "返回步道", contents: "本页目录" },
  about: {
    kicker: "关于我们",
    title: "诞生于峡湾公路上的巨魔寻宝。",
    lead: "Trollfossjakten 把 Lavangen 与 Årstein 之间 45 公里的公路变成一场民间传说寻宝之旅——84 个手绘巨魔、9 座瀑布，以及截然不同的四季。",
    sections: [
      { h: "创意来源", p: ["挪威北部到处流传着巨魔的故事：日出时化为石头的巨魔、住在瀑布后面的巨魔、守护桥梁和沼泽的巨魔。我们希望给家庭、徒步者和游客一个走出家门的理由，在每个季节探索 Lavangen 与 Gratangen 之间的峡湾。"] },
      { h: "玩法", p: ["下载免费应用，沿路线步行、骑车、滑雪或轮滑，到达巨魔所在地时把它捕获。61 个巨魔永久免费。通行证可解锁最稀有的巨魔，巨魔克朗可以在沿途的本地合作商家使用。"] },
      { h: "挪威北部制造", p: ["Trollfossjakten 由挪威北部的小公司 ATE Arctic Sales & Marketing 开发。项目得到 Lavangen 市政府以及本地合作伙伴的支持，他们和我们一样热爱这片峡湾、瀑布和属于它们的故事。"] },
      { h: "爱护步道", p: ["路线沿公共道路延伸，途经农场、海岸和森林。请遵守自由通行权（allemannsretten），与车辆保持安全距离，把垃圾带走，也别打扰真正的巨魔。"] },
    ],
  },
  press: {
    kicker: "媒体",
    title: "媒体资料与联系方式。",
    lead: "正在撰写关于 Trollfossjakten 的报道？这里有关键信息、简介和联系方式。我们乐意协助安排采访、提供图片和应用测试权限。",
    sections: [
      { h: "简介", p: ["Trollfossjakten（The Troll Waterfall Quest，巨魔瀑布寻宝）是一款可免费开始的手机游戏，把挪威北部特罗姆斯郡 Lavangen 与 Årstein 之间的公路变成老少皆宜的户外巨魔寻宝之旅。"] },
      { h: "关键信息", list: ["沿 45 公里峡湾公路分布的 84 个手绘巨魔", "路线上有 9 座瀑布", "61 个巨魔永久免费，无需注册", "全年可玩：冬季滑雪，夏季步行、骑车或轮滑", "为萨米和挪威节日准备的节日巨魔", "支持挪威语、北萨米语、英语、中文、俄语和泰语"] },
      { h: "标志与插画", p: ["我们的标志和巨魔插画可用于关于 Trollfossjakten 的新闻报道，请勿修改。如需高清文件和截图，请联系我们。"] },
      { h: "媒体联系", p: ["ATE Arctic Sales & Marketing · {email}"] },
    ],
    asset: "下载标志（PNG）",
  },
  privacy: {
    kicker: "隐私",
    title: "隐私政策",
    lead: "我们尽可能少地收集数据。本政策说明 Trollfossjakten 网站和应用会处理哪些个人数据、处理的原因，以及您依据 GDPR 和挪威法律享有的权利。",
    sections: [
      { h: "1. 数据控制者", p: ["数据控制者为 ATE Arctic Sales & Marketing（组织编号 936314392），挪威。联系方式：{email}。"] },
      { h: "2. 本网站", p: ["无需注册即可使用本网站。我们不使用广告 Cookie，也从不出售个人数据。", "您选择的语言会保存在浏览器的本地存储中，以便网站记住它。该数据只留在您的设备上。", "我们使用注重隐私的访问统计来了解哪些页面被访问并修复错误，这可能会在您的浏览器中存储一个随机标识符。"] },
      { h: "3. 联系表单", p: ["当您给我们发送消息时，我们会处理您的姓名、电子邮箱、消息内容和 IP 地址（用于防止垃圾信息）。这些数据仅用于回复您。法律依据是我们回复咨询的正当利益（GDPR 第 6 条第 1 款 f 项）。消息在不再需要时删除，最迟在我们与您最后一次联系后 24 个月内删除。"] },
      { h: "4. 地图", p: ["步道地图从 OpenStreetMap 加载地图图块，并从 OSRM 路线服务获取步行路线。您的浏览器会连接它们的服务器，对方可以看到您的 IP 地址。除此之外，我们不向它们发送任何信息。"] },
      { h: "5. SOS 页面", p: ["只有在您点击“检测我的位置”后，SOS 页面才会读取您的位置。位置、消息和照片都保留在您的设备上，只通过手机自带的分享菜单发送给您选择的人，不会发送到我们的服务器。"] },
      { h: "6. 手机应用", p: ["无需账号即可游玩。游戏过程中，应用会使用您的位置来显示附近的巨魔并记录捕获。您可以随时在手机设置中关闭定位权限。", "通行证通过 App Store 或 Google Play 购买，由 Apple 或 Google 处理付款——我们永远看不到您的银行卡信息。"] },
      { h: "7. 数据共享对象", p: ["我们使用可信赖的服务商提供托管和邮件投递服务。它们仅按照我们的指示、依据数据处理协议处理数据。如数据在欧洲经济区以外处理，我们依据欧盟标准合同条款或其他合法的传输依据。"] },
      { h: "8. 您的权利", p: ["您有权访问、更正和删除您的个人数据，限制或反对处理，以及要求数据可携带。请发邮件至 {email}，我们会在 30 天内答复。您也可以向挪威数据保护局（Datatilsynet）投诉。"] },
      { h: "9. 儿童", p: ["本游戏为家庭设计。13 岁以下儿童应在父母或监护人陪同下游玩。我们不会有意通过联系表单收集儿童的个人数据。"] },
      { h: "10. 变更", p: ["网站或应用发生变化时，我们可能会更新本政策。页面顶部的日期始终表示最新版本。"] },
    ],
  },
  terms: {
    kicker: "条款",
    title: "使用条款",
    lead: "本条款适用于 Trollfossjakten 网站和应用。使用即表示您接受以下条款——请仔细阅读，尤其是安全部分。",
    sections: [
      { h: "1. 服务", p: ["Trollfossjakten 由 ATE Arctic Sales & Marketing（组织编号 936314392，挪威）提供。本应用是一款户外游戏，您可以在 Lavangen 与 Årstein 之间的公路沿线寻找并收集虚拟巨魔。"] },
      { h: "2. 安全第一", p: ["参与风险由您自行承担。部分路线沿公共道路：请遵守交通规则，驾车或骑车时切勿使用手机，并照看好孩子。出发前请查看天气、路况和日照时间，按季节着装，并告诉他人您的计划。紧急情况下请拨打 112。"] },
      { h: "3. 自然与私人财产", p: ["请遵守自由通行权（allemannsretten）。尊重农场、花园、放牧的动物和私人土地——即使看起来有巨魔站在那里。请把垃圾带走。"] },
      { h: "4. 通行证与付款", p: ["61 个巨魔永久免费。史诗通行证和稀有通行证可解锁更多巨魔，自激活之日起有效 365 天。价格以应用内显示为准，首发价格限时提供。", "购买通过 App Store 或 Google Play 完成，并遵循其付款与退款条款。根据挪威《撤回权法》，数字内容的 14 天撤回权在您激活通行证时终止；购买前会请您确认。"] },
      { h: "5. 巨魔克朗与合作优惠", p: ["巨魔克朗是没有现金价值的应用内货币，不能兑换现金或转让给其他玩家。合作商家的优惠由商家自行提供，并由其对自身产品和服务负责。"] },
      { h: "6. 公平游戏", p: ["请勿作弊——例如伪造 GPS 位置、使用机器人或利用漏洞——也不要滥用服务或试图破坏其安全。如有严重或屡次滥用，我们可能暂停您的使用权限。"] },
      { h: "7. 内容与权利", p: ["巨魔、插画、文字、标志和软件归 ATE Arctic Sales & Marketing 或我们的许可方所有。您可以出于个人非商业用途分享截图。地图数据 © OpenStreetMap 贡献者。"] },
      { h: "8. 可用性与变更", p: ["我们努力保持服务正常运行，但无法保证服务始终可用或没有错误。巨魔、活动和功能可能发生变化，例如节日日期调整时。条款如有重要变更，我们会通知您。"] },
      { h: "9. 责任", p: ["在法律允许的范围内，我们不对间接损失负责，也不对因路线、天气、交通或您使用应用的方式造成的伤害或损失负责。本条款不限制您依据挪威法律享有的消费者权利。"] },
      { h: "10. 适用法律与争议", p: ["本条款受挪威法律管辖。如双方无法协商解决分歧，消费者可联系挪威消费者管理局（Forbrukertilsynet）或向挪威法院提起诉讼。"] },
      { h: "11. 联系", p: ["对条款有疑问？请发邮件至 {email}。"] },
    ],
  },
  contact: {
    kicker: "联系我们",
    title: "我们随时为您提供帮助",
    lead: "有问题、反馈或需要帮助？请联系我们，我们会尽快回复。",
    formTitle: "给我们留言",
    name: "姓名",
    email: "电子邮箱",
    message: "留言",
    namePh: "您的姓名",
    emailPh: "you@example.com",
    messagePh: "我们能帮您什么？",
    send: "发送留言",
    sending: "正在发送…",
    sent: "谢谢！您的留言已发送。",
    sentBody: "我们会尽快回复您。",
    another: "再发一条留言",
    error: "留言发送失败。请重试，或直接给我们发邮件。",
    tooMany: "短时间内留言过多，请稍后再试。",
    invalid: "请填写姓名、有效的电子邮箱和至少 10 个字符的留言。",
    consent: "您的信息仅用于回复本次留言。请阅读我们的{privacy}。",
    privacyLink: "隐私政策",
    prefill: "您好！我们对“{package}”支持者套餐感兴趣，请与我们联系以讨论细节。",
    prefillCustom: "您好！我们对定制巨魔路线感兴趣，请与我们联系以讨论我们的需求。",
    prefillGeneric: "您好！我们有意成为 Trollfossjakten 的支持者，请与我们联系以讨论合作方式。",
    company: "公司",
    orgNr: "组织编号",
    location: "所在地",
    locationValue: "挪威",
    emailLabel: "电子邮箱",
    whyTitle: "为什么联系我们？",
    why: [
      "技术支持与应用使用帮助",
      "关于通行证、价格和巨魔克朗的问题",
      "成为商家巨魔合作伙伴或赞助商",
      "媒体、合作与伙伴关系机会",
      "报告问题或提供反馈",
    ],
    cta: "给我们留言",
  },
};

export default zh;
